import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    clipRule="evenodd"
    d="M5.22871 5.23273C5.02419 5.43731 4.9093 5.71474 4.9093 6.00401C4.9093 6.29328 5.02419 6.5707 5.22871 6.77528L10.4574 12.004L5.22871 17.2327C5.02999 17.4385 4.92003 17.714 4.92252 18.0001C4.925 18.2861 5.03973 18.5597 5.24199 18.762C5.44426 18.9643 5.71787 19.079 6.0039 19.0815C6.28994 19.084 6.5655 18.974 6.77125 18.7753L12 13.5466L17.2287 18.7753C17.4345 18.974 17.71 19.084 17.9961 19.0815C18.2821 19.079 18.5557 18.9643 18.758 18.762C18.9602 18.5597 19.075 18.2861 19.0774 18.0001C19.0799 17.714 18.97 17.4385 18.7712 17.2327L13.5425 12.004L18.7712 6.77528C18.97 6.56953 19.0799 6.29396 19.0774 6.00793C19.075 5.7219 18.9602 5.44829 18.758 5.24602C18.5557 5.04376 18.2821 4.92903 17.9961 4.92654C17.71 4.92406 17.4345 5.03402 17.2287 5.23273L12 10.4615L6.77125 5.23273C6.56667 5.02822 6.28925 4.91333 5.99998 4.91333C5.71071 4.91333 5.43328 5.02822 5.22871 5.23273Z"
    fillRule="evenodd"
  />,
  'Cross',
)
